/* global pendo */
import { useEffect, useState, createContext } from "react";
import { Toaster } from "react-hot-toast";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./AppRoot.css";
import { selectUIStates, selectUser } from "../../../redux/features/appData";
import { AppHeader } from "../app-header/AppHeader";
import { WazToolbar } from "../../wazawan/toolbar/WazToolbar";
import { AppSidebar } from "../sidebar/AppSidebar";

type AppRootProps = {};
export const AppRoot = ({}: AppRootProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeUser = useSelector(selectUser);
  const uiStates = useSelector(selectUIStates);
  const selectedTool = uiStates.selectedTool;
  const appSelectedMenu = uiStates.appSelectedMenu;

  if (storeUser) {
    document.body.className = storeUser.theme;
  }

  // console.log("[AppRoot/main] storeUser: ", storeUser);

  useEffect(() => {
    // get the current path
    const path = window.location.pathname;
    // console.log("[AppRoot] path: ", path);

    const root = path === "/app" || path === "/app/";
    // console.log("[AppRoot] root: ", root);
    // console.log("[AppRoot] selectedTool: ", selectedTool);
    // console.log("[AppRoot] appSelectedMenu: ", appSelectedMenu);
  }, [uiStates]);

  return (
    <>
      <div id="app-root">
        <WazToolbar viewingApp={true} />
        <AppSidebar />

        <div className="app-contents">
          <AppHeader />
          <div className="app-body">
            <Outlet context={[]} />
          </div>
        </div>
      </div>

      {/* <Toaster /> */}
    </>
  );
};
